import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AssigneesModule } from "@webapp/assignees/assignees.module";
import { LocalizationModule } from "@webapp/localization/localization.module";
import { ButtonSelectModule } from "@webapp/shared/components/button-select/button-select.module";
import { MultiSelectorModule } from "@webapp/shared/components/multi-selector/multi-selector.module";
import { IndicatorModule } from "@webapp/shared/indicator/indicator.module";
import { UiAssigneeModule } from "@webapp/ui/assignee/assignee.module";
import { UiButtonModule } from "@webapp/ui/button/button.module";
import { UiDropdownModule } from "@webapp/ui/dropdown/dropdown.module";
import { UiFormModule } from "@webapp/ui/form/form.module";
import { UiGridModule } from "@webapp/ui/grid/grid.module";
import { UiIconModule } from "@webapp/ui/icon/icon.module";
import { UiInputModule } from "@webapp/ui/input/input.module";
import { UiSelectModule } from "@webapp/ui/select/select.module";
import { UiTooltipModule } from "@webapp/ui/tooltip/tooltip.module";
import { UiTreeSelectModule } from "@webapp/ui/tree-select/tree-select.module";
import { UiTreeModule } from "@webapp/ui/tree/tree.module";
import { UiTypographyModule } from "@webapp/ui/typography/typography.module";
import { RelatedItemRowComponent } from "./components/related-item-row/related-item-row.component";
import { RelatedItemsComponent } from "./components/related-items-component/related-items.component";
import { RelatedItemsSelectorComponent } from "./components/related-items-selector/related-items-selector.component";
import { RelationshipOptionsButtonComponent } from "./components/relationship-options-button/relationship-options-button.component";

@NgModule({
  imports: [
    FormsModule,
    LocalizationModule,
    UiTreeModule,
    UiGridModule,
    UiDropdownModule,
    UiIconModule,
    UiTooltipModule,
    UiSelectModule,
    UiButtonModule,
    AssigneesModule,
    UiInputModule,
    IndicatorModule,
    UiTypographyModule,
    UiAssigneeModule,
    UiTreeSelectModule,
    ReactiveFormsModule,
    UiFormModule,
    CommonModule,
    ButtonSelectModule,
    MultiSelectorModule,
  ],
  declarations: [RelatedItemsComponent, RelatedItemRowComponent, RelationshipOptionsButtonComponent, RelatedItemsSelectorComponent],
})
export class LinksModule {}
